import {ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {AnimationOptions, LottieComponent} from "ngx-lottie";

@Component({
  selector: 'app-preview-container-loader',
  imports: [
    LottieComponent
  ],
  templateUrl: './preview-container-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewContainerLoaderComponent {
  @Input("isVisible") public isVisible: boolean = false;

  public loadingDotsLgOptions: AnimationOptions = {
    path: `/assets/lottie/loading_dots_lg_white.json`, loop: true, autoplay: true,
  };
}
